import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

const buildLoginRedirect = (requestedUrl: string) =>
  inject(Router).createUrlTree(['/authentication/login'], {
    queryParams: { redirect: requestedUrl }
  });

export const authGuard: CanActivateFn = (_, state) => {
  const auth = inject(AuthService);

  if (auth.isAuthenticated() && !auth.hasExpiredSession()) {
    return true;
  }

  if (auth.isAuthenticated() && auth.hasExpiredSession()) {
    auth.logout({ redirectToLogin: true, reason: 'session-expired' });
    return false;
  }

  return buildLoginRedirect(state.url);
};

export const authChildGuard: CanActivateChildFn = (_, state) => {
  const auth = inject(AuthService);

  if (auth.isAuthenticated() && !auth.hasExpiredSession()) {
    return true;
  }

  if (auth.isAuthenticated() && auth.hasExpiredSession()) {
    auth.logout({ redirectToLogin: true, reason: 'session-expired' });
    return false;
  }

  return buildLoginRedirect(state.url);
};
